import styled from "styled-components"
import { customMedia } from "../../styles/customMedia"

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 0 20px;

  ${customMedia.greaterThan("smallDesktop")`
    padding: 0 15%;

    h1 {
      margin-top: 50px;
      font-size: 58px;
      line-height: 1.2;
    }
    p {
      font-size: 34px;
      line-height: 1.2;
    }
  `}

  ${customMedia.greaterThan("mediumDesktop")`
    h1 {
      font-size: 50px;
      line-height: 1.2;
    }
    p {
      font-size: 20px;
      line-height: 2;
    }
  `}

  ${customMedia.greaterThan("hugeDesktop")`
    h1 {
      font-size: 60px;
      line-height: 1.2;
    }
  `}
`

export const Content = styled.div`
  display: flex;
  position: relative;
  flex-shrink: 0;
  justify-content: space-between;
  gap: 80px;
  height: 100vh;
  height: calc(100% - 200px);
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${customMedia.greaterThan("mediumDesktop")`
    width: 40%;
    padding: 3% 0;
  `}
`

export const RightContainer = styled.div`
  flex: 1;
  height: 100%;
  align-self: flex-end;
  display: none;
  flex-direction: column;
  justify-content: space-between;
`

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  ${customMedia.greaterThan("smallDesktop")`
    display: none;
  `}
`

export const ArrowContainerWeb = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 16px;
  ${customMedia.greaterThan("smallDesktop")`
    display: flex;
  `}
`
